import {useState} from 'react';
import type {VisitedStats} from 'server/apiHandlers/getVisitedStatsHandler';
import {signpostFill, skipDownLine, skipUpLine} from 'src/utils/icons';
import {setSearchParam} from 'src/hooks/useSearchParam';
import ProgressCircle from '../common/ProgressCircle';
import BaseButton from '../BaseButton';
import RemixIcon from '../RemixIcon';

type Props = {
  visitedStats: VisitedStats;
};

const MapPlaceListsStats = ({visitedStats}: Props) => {
  const [showAllLists, setShowAllLists] = useState(false);

  return (
    <>
      <div className="mt-3">
        <h4 className="text font-semibold px-3 py-4 text-(--gray-text) flex items-center">
          <RemixIcon icon={signpostFill} size={21} className="ml-[2px] mr-[14px] mb-px" color="var(--gray-text)" />
          Where to go next?
        </h4>

        <div className="flex flex-col">
          {visitedStats.placeListsStats.slice(0, showAllLists ? 20 : 7).map((placeListStats) => {
            const percentage = (placeListStats.intersection / (placeListStats.numberOfPlaces || 1000)) * 100;

            return (
              <BaseButton
                key={placeListStats.nameId}
                onPress={() => setSearchParam('places-list', placeListStats.nameId)}
                buttonVariant="text"
                className="duration-0 w-full text-left justify-start items-start leading-snug h-auto rounded-3xl gap-3 px-2 py-2"
              >
                <div className="p-1 rounded-full flex items-center justify-center bg-(--green-secondary)">
                  <ProgressCircle progress={percentage} color="var(--green-primary)" />
                </div>

                <span className="grow mt-[5px]">{placeListStats.name}</span>
              </BaseButton>
            );
          })}
        </div>

        {visitedStats.placeListsStats.length > 7 ? (
          <div className="flex justify-center mt-2">
            <BaseButton
              color="var(--gray-text)"
              onPress={() => setShowAllLists(!showAllLists)}
              label={showAllLists ? 'Show less' : 'Show more'}
              icon={showAllLists ? skipUpLine : skipDownLine}
              buttonVariant="text"
              size="small"
            />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default MapPlaceListsStats;
